export const process_routes = function(routes_tree) {
    var flat_routes = [];

    var processor = function(_routes, parent){
        _routes.forEach(function(route, index) {
            if(parent) {
                if (!parent.children_only) {
                    route.parent = parent.name;
                }
                // take parent meta object and update it with child items
                route.meta = Object.assign({}, parent.meta, route.meta);
            }
            var _route = {
                name: route.name,
                path: route.path,
                component: route.component,
                title: route.title,
                meta: { ...route.meta, title: route.title },
                parent: route.parent || null,
                props: route.props,
            }
            if(route.redirect) {
                _route.redirect = route.redirect;
            }
            if(route.children_only) {
                _route.children_only = route.children_only;
            }
            flat_routes.push(_route);

            if(route.children) {
                processor(route.children, _route);
            }
        });
    }
    processor(routes_tree, null);

    return flat_routes;
}

export const filter_routes = function(routes, filter) {
    /**
     * Returns a list of routes that satisfy the filter.
     * @param routes Array of route objects to filter.
     * @param filter A function that returns true if the route should be included, else false.
     */
    const ret = [];
    for (let route of routes) {
        // If filter passes, filter route children
        if (filter(route)) {
            if (route.children) {
                // deep copy route so we can edit the children
                route = JSON.parse(JSON.stringify(route));
                route.children = filter_routes(route.children, filter);
            }
            if (route.children && route.children_only) {
                // ignore the route and only add its children
                route.children.forEach((child) => ret.push(child));
            } else {
                ret.push(route);
            }
        }
    }
    return ret;
}
